import { MonitoringFilterItem } from './monitoring-filter-item';

export class MonitoringFilters {
    items: MonitoringFilterItem[] = [];

    startDate: Date;
    endDate:   Date;

    constructor () {
        this.endDate   = new Date()                   ;
        this.startDate = this.getYearAgo(this.endDate);
    }

    clone (): MonitoringFilters {
        const clone = new MonitoringFilters();

        clone.items     = this.items    ;
        clone.startDate = this.startDate;
        clone.endDate   = this.endDate  ;

        return clone;
    }

    private getYearAgo (date: Date): Date {
        var result = new Date(date);
        result = new Date(result.setFullYear(result.getFullYear() - 1));

        const isFeb29 = date.getMonth() === 1 && date.getDate() == 29;
        if (!isFeb29) {
            result = new Date(result.setDate(result.getDate() + 1));
        }

        return result;
    }

}
